import { isSSR } from '@helpers/ssr';
import { useBreakpoint } from '@vivino/js-react-common-ui';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { fetchExploreVintages } from 'vivino-js/api/explore';

import TakeOverBanner from '@components/AppBanner/TakeOverBanner';

import PurchaseAvailabilityPPCPresentational from './PurchaseAvailabilityPPC.presentational';
import styles from './purchaseAvailabilityPPC.scss';

const getExploreQueryParams = ({ vintage }) => {
  let minRating;

  if (vintage.has_valid_ratings) {
    minRating = vintage.statistics?.ratings_average;
  } else if (vintage.wine.has_valid_ratings) {
    minRating = vintage.wine.statistics?.ratings_average;
  }
  const exploreQuery = {
    wineStyleIds: [vintage.wine?.style?.id],
    merchantType: 'vc',
  };

  if (minRating) {
    exploreQuery.minRating = minRating;
    exploreQuery.orderBy = 'price';
    exploreQuery.order = 'asc';
  } else {
    exploreQuery.orderBy = 'ratings_count';
    exploreQuery.order = 'desc';
  }

  return exploreQuery;
};

const PurchaseAvailabilityPPC = ({
  availability,
  vintage,
  marketInformation,
  wineStyleMedianExperimentVariant,
  onLoaded,
}) => {
  const [betterValueExplorerVintage, setBetterValueExplorerVintage] = useState(vintage);

  const { isMobile } = useBreakpoint();

  useEffect(() => {
    const wineStyleId = vintage?.wine?.style?.id;

    if (wineStyleId) {
      const exploreQuery = getExploreQueryParams({ vintage });
      const minRequiredResults = exploreQuery.minRating ? 1 : 5;

      fetchExploreVintages(exploreQuery)
        .then(({ explore_vintage }) => {
          if ((explore_vintage?.records?.length || 0) >= minRequiredResults) {
            setBetterValueExplorerVintage(explore_vintage.records[0]);
          } else {
            setBetterValueExplorerVintage(null);
          }
        })
        .finally(() => {
          onLoaded?.();
        });
    } else {
      onLoaded?.();
    }
  }, []);

  return (
    <>
      <PurchaseAvailabilityPPCPresentational
        vintage={vintage}
        availability={availability}
        marketInformation={marketInformation}
        betterValueExplorerVintage={betterValueExplorerVintage}
        wineStyleMedianExperimentVariant={wineStyleMedianExperimentVariant}
      />
      {!isSSR && isMobile && (
        <div className={styles.takeOverBanner}>
          <TakeOverBanner />
        </div>
      )}
    </>
  );
};

PurchaseAvailabilityPPC.propTypes = {
  availability: PropTypes.object,
  vintage: PropTypes.object,
  marketInformation: PropTypes.object,
  wineStyleMedianExperimentVariant: PropTypes.object,
  onLoaded: PropTypes.func,
};

export default PurchaseAvailabilityPPC;
